export const OVERALL_CATEGORY_MANDATORY_FLAG = '*'
export const READONLY_FLAGS = 'IsOPSTopPartner,IsBPSTopPartner,IsTopDistributor'
export const TOP_PARTNER_FLAGS = 'IsOPSTopPartner,IsBPSTopPartner,IsTopDistributor'
export const MANDATORY_CATEGORY_VISIBLE_SUFFIX = '!'
export const MANDATORY_CATEGORY_CONTRACTUAL_SUFFIX = '#'
